export const theme: any = {
	colors: {
		blue: "#00157d",
	},
}
